import React, { useEffect, useState } from "react";

const API_BASE_URL = "https://dizv6b75kj46r.cloudfront.net";

export default function VerifyEmail() {
  const [status, setStatus] = useState("verifying"); // verifying|ok|error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const email = params.get("email");
    const token = params.get("token");

    if (!email || !token) {
      setStatus("error");
      setMsg("Missing email or token.");
      return;
    }

    fetch(`${API_BASE_URL}/verify_email?email=${encodeURIComponent(email)}&token=${encodeURIComponent(token)}`, {
      method: "GET",
    })
      .then(async (r) => {
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data?.error || "Verification failed");
        return data;
      })
      .then((data) => {
        setStatus("ok");
        setMsg(data?.message || "Verified!");
      })
      .catch((e) => {
        setStatus("error");
        setMsg(e.message);
      });
  }, []);

  return (
    <div style={{ padding: 40, fontFamily: "Arial" }}>
      {status === "verifying" && <h2>Verifying…</h2>}
      {status === "ok" && <h2>✅ {msg}</h2>}
      {status === "error" && <h2>❌ {msg}</h2>}
      <p><a href="/login">Go to login</a></p>
    </div>
  );
}
